import { useNavigate } from "react-router-dom";

const FOOTER_ROUTES = {
  top: "/",
  shop: "/shop",
  spaces: "/spaces",
  story: "/story",
  craft: "/craft",
  visit: "/visit",
  ambaari: "/ambaari",
  book: "/book",
};

export default function Footer() {
  const navigate = useNavigate();
  const go = (id) => navigate(FOOTER_ROUTES[id] || "/");
  return (
    <footer data-testid="site-footer" className="bg-oxblood-ink pt-20 pb-10 overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <button
          data-testid="footer-wordmark"
          onClick={() => go("top")}
          className="block w-full text-left font-display text-outline-ivory hover:text-ivory/10 transition-colors duration-700 text-[11.5vw] leading-none tracking-tight whitespace-nowrap"
        >
          JAIPUR FURNITURE
        </button>

        <div className="mt-16 flex flex-col md:flex-row justify-between gap-10 border-t border-ivory/10 pt-10">
          <div>
            <img src="/logo-ivory.png" alt="Jaipur Furniture logo" className="h-16 w-auto mb-5" />
            <p className="font-display text-ivory text-lg">Jaipur Furniture</p>
            <p className="text-brass-soft text-xs tracking-[0.3em] uppercase mt-1">by Yojna Jaisingh</p>
            <p className="text-ivory/40 font-light text-sm mt-4 max-w-xs leading-relaxed">
              Handcrafted solid wood furniture, bespoke interiors and premium home décor — Malviya Nagar, Jaipur.
            </p>
          </div>
          <div className="flex gap-16">
            <div className="flex flex-col gap-3">
              <span className="text-brass-soft text-[10px] tracking-[0.35em] uppercase mb-2">Explore</span>
              {[["shop", "Shop"], ["spaces", "Spaces"], ["story", "Story"], ["craft", "Craft"], ["visit", "Visit"], ["ambaari", "Ambaari"]].map(([id, label]) => (
                <button key={id} data-testid={`footer-link-${id}`} onClick={() => go(id)} className="text-ivory/60 hover:text-brass-soft text-sm font-light text-left transition-colors duration-300">
                  {label}
                </button>
              ))}
            </div>
            <div className="flex flex-col gap-3">
              <span className="text-brass-soft text-[10px] tracking-[0.35em] uppercase mb-2">House</span>
              <span className="text-ivory/60 text-sm font-light">AMBAARI — soon</span>
              <button data-testid="footer-link-book" onClick={() => go("book")} className="text-ivory/60 hover:text-brass-soft text-sm font-light text-left transition-colors duration-300">
                Book Online
              </button>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col md:flex-row justify-between gap-4 text-ivory/35 text-xs font-light tracking-wide">
          <span>© 2026 Jaipur Furniture by Yojna Jaisingh. All rights reserved.</span>
          <span className="font-display italic">Furniture that tells your story.</span>
        </div>
      </div>
    </footer>
  );
}
